import { useFeatureFlagQuery } from '@leagueplatform/user-profile-api';
import { SELF_REPORTED_DATA_ENABLED } from '#constants/feature-flags.constants.ts';

export const useIsSelfReportedDataEnabled = () => {
  const { isLoading, data: isSelfReportedDataEnabled } = useFeatureFlagQuery(
    SELF_REPORTED_DATA_ENABLED,
  );

  return {
    isLoading,
    isSelfReportedDataEnabled,
  };
};
